<template>
    <div class="report-management">
        <!-- 周期对比报表导出 -->
        <div class="module-section">
            <div class="module-title">周期对比报表导出</div>
            <div class="search_nav">
                <el-form :inline="true" class="demo-form-inline">
                    <el-form-item label="场站（可多选）：">
                        <el-select v-model="periodCompareForm.stationIds" multiple filterable clearable placeholder="请选择场站" style="width: 200px;" collapse-tags collapse-tags-tooltip>
                            <el-option
                                v-for="item in stationOptions"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="对比周期：">
                        <el-select v-model="periodCompareForm.compareType" placeholder="请选择" style="width: 150px;">
                            <el-option label="日对比" :value="1"></el-option>
                            <el-option label="周对比" :value="2"></el-option>
                            <el-option label="月对比" :value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="时间范围">
                        <el-date-picker
                            v-model="periodCompareForm.dateRange"
                            type="daterange"
                            value-format="YYYY-MM-DD"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 280px;"
                        />
                    </el-form-item>
                    <el-form-item>
                        <div class="button_group">
                            <el-button type="primary" @click="exportPeriodCompareTotal">导出总表</el-button>
                            <el-button type="primary" @click="exportPeriodCompareDetail">导出明细表</el-button>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <!-- 数据统计导出 -->
        <div class="module-section">
            <div class="module-title">数据统计导出</div>
            <div class="search_nav">
                <el-form :inline="true" class="demo-form-inline">
                    <el-form-item label="场站（可多选）：">
                        <el-select v-model="dataStatsForm.stationIds" multiple filterable clearable placeholder="请选择场站" style="width: 200px;" collapse-tags collapse-tags-tooltip>
                            <el-option
                                v-for="item in stationOptions"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="统计维度：">
                        <el-select v-model="dataStatsForm.statsType" placeholder="请选择" style="width: 150px;">
                            <el-option label="按日统计" :value="1"></el-option>
                            <el-option label="按周统计" :value="2"></el-option>
                            <el-option label="按月统计" :value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="时间范围">
                        <el-date-picker
                            v-model="dataStatsForm.dateRange"
                            type="daterange"
                            value-format="YYYY-MM-DD"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 280px;"
                        />
                    </el-form-item>
                    <el-form-item>
                        <div class="button_group">
                            <el-button type="primary" @click="exportDataStatsTotal">导出总表</el-button>
                            <el-button type="primary" @click="exportDataStatsDetail">导出明细表</el-button>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <!-- 利用率报表导出 -->
        <div class="module-section">
            <div class="module-title">利用率报表导出</div>
            <div class="search_nav">
                <el-form :inline="true" class="demo-form-inline">
                    <el-form-item label="场站（可多选）：">
                        <el-select v-model="utilizationForm.stationIds" multiple filterable clearable placeholder="请选择场站" style="width: 200px;" collapse-tags collapse-tags-tooltip>
                            <el-option
                                v-for="item in stationOptions"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="统计周期：">
                        <el-select v-model="utilizationForm.periodType" placeholder="请选择" style="width: 150px;">
                            <el-option label="日" :value="1"></el-option>
                            <el-option label="周" :value="2"></el-option>
                            <el-option label="月" :value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="时间范围">
                        <el-date-picker
                            v-model="utilizationForm.dateRange"
                            type="daterange"
                            value-format="YYYY-MM-DD"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 280px;"
                        />
                    </el-form-item>
                    <el-form-item>
                        <div class="button_group">
                            <el-button type="primary" @click="exportUtilization">导出</el-button>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <!-- 周报导出 -->
        <div class="module-section">
            <div class="module-title">周报导出</div>
            <div class="search_nav">
                <el-form :inline="true" class="demo-form-inline">
                    <el-form-item label="场站（可多选）：">
                        <el-select v-model="weeklyReportForm.stationIds" multiple filterable clearable placeholder="请选择场站" style="width: 200px;" collapse-tags collapse-tags-tooltip>
                            <el-option
                                v-for="item in stationOptions"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="周报日期">
                        <el-date-picker
                            v-model="weeklyReportForm.weekDate"
                            type="week"
                            value-format="YYYY-MM-DD"
                            format="YYYY 第 ww 周"
                            placeholder="选择周"
                            style="width: 200px;"
                        />
                    </el-form-item>
                    <el-form-item>
                        <div class="button_group">
                            <el-button type="primary" @click="exportWeeklyReport">导出</el-button>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import { ElMessage } from 'element-plus';

export default {
    name: 'ReportManagement',
    data() {
        return {
            stationOptions: [],
            periodCompareForm: {
                stationIds: [],
                compareType: '',
                dateRange: [],
            },
            dataStatsForm: {
                stationIds: [],
                statsType: '',
                dateRange: [],
            },
            utilizationForm: {
                stationIds: [],
                periodType: '',
                dateRange: [],
            },
            weeklyReportForm: {
                stationIds: [],
                weekDate: '',
            },
        }
    },
    mounted() {
        this.getStationOptions();
    },
    watch: {
        '$store.state.stationList': {
            handler(newVal) {
                if (newVal && newVal.length > 0) {
                    this.stationOptions = newVal;
                }
            },
            immediate: true
        }
    },
    methods: {
        getStationOptions() {
            this.stationOptions = this.$store.state.stationList || [];
        },
        exportPeriodCompareTotal() {
            let that = this;
            let param = {};
            if (that.periodCompareForm.stationIds.length > 0) {
                param.stationIds = that.periodCompareForm.stationIds;
            }
            if (that.periodCompareForm.compareType) {
                param.compareType = that.periodCompareForm.compareType;
            }
            if (that.periodCompareForm.dateRange && that.periodCompareForm.dateRange.length === 2) {
                param.startDate = that.periodCompareForm.dateRange[0];
                param.endDate = that.periodCompareForm.dateRange[1];
            }
            that.$axios.post(that.$store.state.platformApi + "report/periodCompare/exportTotal", JSON.stringify(param), {responseType: 'blob'}).then(result => {
            });
        },
        exportPeriodCompareDetail() {
            let that = this;
            let param = {};
            if (that.periodCompareForm.stationIds.length > 0) {
                param.stationIds = that.periodCompareForm.stationIds;
            }
            if (that.periodCompareForm.compareType) {
                param.compareType = that.periodCompareForm.compareType;
            }
            if (that.periodCompareForm.dateRange && that.periodCompareForm.dateRange.length === 2) {
                param.startDate = that.periodCompareForm.dateRange[0];
                param.endDate = that.periodCompareForm.dateRange[1];
            }
            that.$axios.post(that.$store.state.platformApi + "report/periodCompare/exportDetail", JSON.stringify(param), {responseType: 'blob'}).then(result => {
            });
        },
        exportDataStatsTotal() {
            let that = this;
            let param = {};
            if (that.dataStatsForm.stationIds.length > 0) {
                param.stationIds = that.dataStatsForm.stationIds;
            }
            if (that.dataStatsForm.statsType) {
                param.statsType = that.dataStatsForm.statsType;
            }
            if (that.dataStatsForm.dateRange && that.dataStatsForm.dateRange.length === 2) {
                param.startDate = that.dataStatsForm.dateRange[0];
                param.endDate = that.dataStatsForm.dateRange[1];
            }
            that.$axios.post(that.$store.state.platformApi + "report/dataStats/exportTotal", JSON.stringify(param), {responseType: 'blob'}).then(result => {
            });
        },
        exportDataStatsDetail() {
            let that = this;
            let param = {};
            if (that.dataStatsForm.stationIds.length > 0) {
                param.stationIds = that.dataStatsForm.stationIds;
            }
            if (that.dataStatsForm.statsType) {
                param.statsType = that.dataStatsForm.statsType;
            }
            if (that.dataStatsForm.dateRange && that.dataStatsForm.dateRange.length === 2) {
                param.startDate = that.dataStatsForm.dateRange[0];
                param.endDate = that.dataStatsForm.dateRange[1];
            }
            that.$axios.post(that.$store.state.platformApi + "report/dataStats/exportDetail", JSON.stringify(param), {responseType: 'blob'}).then(result => {
            });
        },
        exportUtilization() {
            let that = this;
            let param = {};
            if (that.utilizationForm.stationIds.length > 0) {
                param.stationIds = that.utilizationForm.stationIds;
            }
            if (that.utilizationForm.periodType) {
                param.periodType = that.utilizationForm.periodType;
            }
            if (that.utilizationForm.dateRange && that.utilizationForm.dateRange.length === 2) {
                param.startDate = that.utilizationForm.dateRange[0];
                param.endDate = that.utilizationForm.dateRange[1];
            }
            that.$axios.post(that.$store.state.platformApi + "report/utilization/export", JSON.stringify(param), {responseType: 'blob'}).then(result => {
            });
        },
        exportWeeklyReport() {
            let that = this;
            let param = {};
            if (that.weeklyReportForm.stationIds.length > 0) {
                param.stationIds = that.weeklyReportForm.stationIds;
            }
            if (that.weeklyReportForm.weekDate) {
                param.weekDate = that.weeklyReportForm.weekDate;
            }
            that.$axios.post(that.$store.state.platformApi + "report/weekly/export", JSON.stringify(param), {responseType: 'blob'}).then(result => {
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.report-management {
    padding: 15px;
}
.module-section {
    margin-bottom: 20px;
    background: #fff;
    border-radius: 5px;
    padding: 15px;
    overflow: hidden;
}
.module-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 15px;
    padding-left: 10px;
    border-left: 3px solid #409EFF;
}
.search_nav {
    width: 100%;
    background: #f5f5f5;
    margin-bottom: 0;
    padding: 15px;
    border-radius: 5px;
    box-sizing: border-box;
}
/* 全局搜索栏标签 96px 放不下"场站（可多选）："，放宽到 126px；
   带 .demo-form-inline 提高优先级，否则会被后注入的 global-search.css 同优先级规则压回 */
.search_nav .demo-form-inline :deep(.el-form-item__label) {
    width: 126px;
    min-width: 126px;
}
.button_group {
    display: flex;
    gap: 10px;
}
</style>